import { useState } from 'react';
import { Flex, Box, Text, VStack, Center, useColorModeValue } from '@chakra-ui/react';
import SimpleSlider from 'components/ui/Slider';

export default function EvaPainScalePreview() {
  const [sliderValue, setSliderValue] = useState(5);
  const bg = useColorModeValue('gray.50', 'gray.900');

  return (
    <Center minH="100vh" bg={bg} p="40px">
      <VStack spacing="48px" w="100%" maxW="700px">
        <Text fontSize="xl" fontWeight="700">
          EVA Pain Scale — Slider Preview
        </Text>

        <Box w="100%" h="1px" bg="gray.200" />

        <VStack spacing="32px" w="100%" align="stretch">
          


          <VStack spacing="8px" align="flex-start">
            <Text fontSize="xs" fontWeight="600" color="gray.400" textTransform="uppercase">
              Tamaño: Medium
            </Text>
            <SimpleSlider
              value={sliderValue}
              onChange={setSliderValue}
              min={0}
              max={10}
              step={1}
              emojis={['😊', '🙂', '🙂', '😐', '😐', '😕', '😕', '😢', '😢', '😭', '😭']}
              label="Nivel de Dolor"
              showValue={true}
              size="md"
              w="300px"
            />
          </VStack>

          <p>Hola</p>

          

          
        </VStack>

        <Box w="100%" h="1px" bg="gray.200" />

        
      </VStack>
    </Center>
  );
}
